// extracted by mini-css-extract-plugin
export var avatarContainer = "_fu-0";
export var gray = "_fu-f";
export var green = "_fu-c";
export var icon = "_fu-9";
export var image = "_fu-1";
export var lg = "_fu-6";
export var md = "_fu-5";
export var presenceDot = "_fu-b";
export var red = "_fu-d";
export var sm = "_fu-4";
export var status = "_fu-a";
export var xl = "_fu-7";
export var xs = "_fu-3";
export var xxl = "_fu-8";
export var xxs = "_fu-2";
export var yellow = "_fu-e";